var map = {
	"./gallery-wip-head-pins_00.jpg": 4854,
	"./gallery-wip-head-pins_01.jpg": 4855,
	"./gallery-wip-head-pins_02.jpg": 4856,
	"./gallery-wip-head-pins_03.jpg": 4857,
	"./gallery-wip-head-pins_04.jpg": 4858,
	"./gallery-wip-head-pins_05.jpg": 4859,
	"./gallery_00.jpg": 4860,
	"./gallery_01.jpg": 4861,
	"./gallery_02.jpg": 4862,
	"./gallery_03.jpg": 4863,
	"./gallery_04.jpg": 4864,
	"./gallery_05.jpg": 4865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4853;